import { CUSTOMERS_TITLE_PREFIX, CUSTOMERS_INDEX_ROUTE } from './consts';

export default () => ({
    label: `${CUSTOMERS_TITLE_PREFIX}s`,
    link: CUSTOMERS_INDEX_ROUTE,
    icon: 'customers',
    permission: 'customers.index',
    order: 70,
});
